import React from 'react';
import { CFormLabel, CFormSelect, CFormFeedback, CPopover } from '@coreui/react-pro';
import PropTypes from 'prop-types';
import CIcon from '@coreui/icons-react';
import { tryParseJSON } from '../../../utils';

const SimpleSelectGroup = ({
     id,
     name,
     typeName,
     value,
     label,
     data,
     dataRefund,
     handleChange,
     isRequired,
     isValidate,
     error,
     optionDefault,
     optionNameDefault,
     disabled,
     tooltip,
     className,
     classNameInput,
     checkRequiredLineDown = false,
}) => {
     const showRequired = () => (isRequired || isValidate) && <CFormFeedback invalid>{error}</CFormFeedback>;
     return (
          <div className={`form-group${className ? ' ' + className : ''}`}>
               {label && (
                    <CFormLabel htmlFor={id}>
                         {<span className="me-1">{label}</span>}
                         {tooltip && (
                              <CPopover content={tooltip} placement="top" trigger="hover">
                                   <CIcon icon="icon-info-cilcle" />
                              </CPopover>
                         )}
                         {isRequired && <span className="text-danger">*</span>}
                    </CFormLabel>
               )}

               <div className="simple-select-wrap">
                    <CFormSelect
                         className={classNameInput}
                         aria-label="Default select"
                         onChange={handleChange}
                         name={name || id}
                         id={id}
                         invalid={(isRequired || isValidate) && !!error}
                         disabled={disabled}
                         value={value}
                    >
                         {optionDefault && <option value="">{optionNameDefault ?? 'Select an option'}&nbsp;&nbsp;</option>}
                         {data?.length > 0 &&
                              data.map((item) => (
                                   <option key={item.id ?? item.value} value={item.id ?? item.value} className="text-dark">
                                        {item[typeName]}&nbsp;&nbsp;
                                   </option>
                              ))}
                         {dataRefund?.length > 0 &&
                              dataRefund.map((type) => {
                                   let arrayEvent = type.event?.name.split('|');

                                   if (arrayEvent?.length === 3) {
                                        arrayEvent = type.event?.name.split('|').slice(0, -1);
                                   } else {
                                        arrayEvent = type.event?.name.split('|');
                                   }

                                   let formattedName = arrayEvent?.toString().replace(',', '|');

                                   if (type.tierId) {
                                        const pricingTiers = tryParseJSON(type.product?.pricingTiers) || [];
                                        const pricingTier = pricingTiers.find((tier) => tier.id === type.tierId);
                                        if (pricingTier) {
                                             const tierName = pricingTier.name;

                                             formattedName = formattedName.replace('Custom Date', tierName);
                                        }
                                   }

                                   const nameEvent = type.event?.startAt || type.tierId ? formattedName : 'Custom Date';

                                   const subName = type.event ? nameEvent : type.isCredit ? 'Date to be selected in the future' : '';

                                   return (
                                        <option key={type.id} value={type.id} className="text-dark">
                                             {type[typeName]} {subName && `(${subName})`}&nbsp;&nbsp;
                                        </option>
                                   );
                              })}
                    </CFormSelect>
                    {!checkRequiredLineDown && showRequired()}
               </div>
               {checkRequiredLineDown && showRequired()}
          </div>
     );
};

SimpleSelectGroup.propTypes = {
     id: PropTypes.string,
     name: PropTypes.string,
     typeName: PropTypes.string,
     value: PropTypes.string,
     label: PropTypes.string,
     data: PropTypes.array,
     dataRefund: PropTypes.array,
     handleChange: PropTypes.func,
     isRequired: PropTypes.bool,
     isValidate: PropTypes.bool,
     error: PropTypes.string,
     optionNameDefault: PropTypes.string,
     optionDefault: PropTypes.bool,
     disabled: PropTypes.bool,
     tooltip: PropTypes.string,
};

SimpleSelectGroup.defaultProps = {
     checked: true,
     typeName: 'name',
     value: '',
     optionDefault: true,
};

export default SimpleSelectGroup;
